export default __webpack_public_path__ + "static/media/x.dcd8630f.svg";